import { CircleUser } from "lucide-react";
import React from "react";
import { IconAvatarContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function IconAvatar(_ref) {
  var icon = _ref.icon;
  var IconComponent = icon || CircleUser;
  return /*#__PURE__*/_jsx(IconAvatarContainer, {
    children: /*#__PURE__*/_jsx(IconComponent, {
      color: "currentColor"
    })
  });
}
export default IconAvatar;